/* unplugin-vue-components disabled */import { render } from "./songer-list.vue?vue&type=template&id=228af6e8&scoped=true&ts=true"
import script from "./songer-list.vue?vue&type=script&lang=ts"
export * from "./songer-list.vue?vue&type=script&lang=ts"

import "./songer-list.vue?vue&type=style&index=0&id=228af6e8&scoped=true&lang=scss"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228af6e8"],['__file',"src/views/artistList/cpns/songer-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "228af6e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('228af6e8', __exports__)) {
    console.log('reload')
    api.reload('228af6e8', __exports__)
  }
  
  module.hot.accept("./songer-list.vue?vue&type=template&id=228af6e8&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('228af6e8', render)
  })

}


export default __exports__